const NOT_APPLICABLE = 'n/a';
const SPONSORED = 'sp';

export const iframeAnalytics = (payload, event) => {
  const {
    apiName,
    anchorProduct,
    itemId,
    strategy,
    position,
    sponsoredInfo
  } = payload;
  const items = [{ productId: itemId, index: position }];
  const isSponsored = sponsoredInfo?.isSponsored;
  const recommendation = {
    recommendationType: apiName,
    pageType: 'cart add overlay',
    anchorProductSku: anchorProduct,
    strategy,
    displayPosition: position,
    recommendationVersion: 'v1',
    recommendedProduct: NOT_APPLICABLE,
    featureVersion: NOT_APPLICABLE,
    interval: NOT_APPLICABLE,
    sponsoredProduct: isSponsored ? SPONSORED : NOT_APPLICABLE
  };

  let analyticsObject = {
    primaryCategory: 'stash',
    eventName: event === 'click' ? 'recommendation pip load' : 'recommendation cart addition',
    eventMode: 'stash',
    stash: {
      recommendation
    },
    sponsoredInfo: sponsoredInfo || {}
  };
  if (event === 'atc') {
    analyticsObject.stash = {
      component: 'product pod',
      item: items,
      recommendation
    };
  }
  return analyticsObject;
};